module.exports = __webpack_public_path__ + "img/petstairs10.4051f5e1.jpg";